<template>
    <div v-if="proj" class="animated fadeIn">
        <!-- 封面區域 -->
        <div class="cover-bg" :style="$tools.style.imgCover($config.checkURL('pic',proj.pic))">
            <b-row class="proj-cover body-top-full justify-content-md-center" align-v="center">
                <b-col md="5" class="text-center">
                    <div class="proj-logo-area">
                        <h1 v-text="proj.name"></h1>
                        <!-- <h3 v-text="$t('menu.project_summary')"></h3> -->
                        <div class="mb-2">
                            <i class="fa fa-calendar block-text"></i>
                            <div class="block-text">{{ $t('menu.start_date') }}:</div>
                            <div class="block-text">{{ proj.start_date }}</div>
                            <div class="block-text">( {{ proj.count_projectDays + ' '  + $t('u.days') }} )</div>
                        </div>
                    </div>

                </b-col>

            </b-row>
        </div>

        <!-- 專案資訊 -->
        <div class="container-fluid">

            <div class="info-block">
                <b-btn class="m-1 header-align-btn" variant="success" aria-controls="collapse_pi"
                    @click="collapse_pi = !collapse_pi" :class="collapse_pi ? 'collapsed' : null"
                    :aria-expanded="collapse_pi ? 'true' : 'false'">
                    {{ $t('menu.project_information') }}
                    <i :class="$tools.style.classToggle(collapse_pi)"></i>
                </b-btn>
                <!-- 服務等級 -->
                <div :class="$tools.style.classServiceLevel(proj.service_level) + ' block-service-level'">
                    <i class="fa fa-shield"></i> {{ $t('status.service_level.' + proj.service_level ) }}
                </div>

                <b-collapse id="collapse_pi" v-model="collapse_pi" class="header-align-collapse">
                    <b-card>
                        <b-row align-v="center">
                            
                            <b-col md="12">

                                <!-- 開始日期 -->
                                <div class="block-md agri-color">
                                    <i class="fa fa-calendar block-text"></i>
                                    <div class="block-text">{{ $t('menu.start_date') }}:</div>
                                    <div class="block-text">{{ proj.start_date }}</div>
                                    <div class="block-text" v-if="proj.end_date"> - {{ proj.end_date }}</div>
                                    <div class="block-text">( {{ proj.count_projectDays + ' '  + $t('u.days') }} )
                                    </div>
                                </div>

                                <!-- 專案到期日期 -->
                                <div :class="'block-md agri-color ' + style_Expiry(proj)" v-if="proj.end_date">
                                    <i class="fa fa-quote-left block-text"></i>
                                    <div class="block-text">{{ $t('menu.expiry_date') }}:</div>
                                    <div class="block-text">{{ proj.end_date }}</div>
                                </div>

                                <!-- 時區 -->
                                <div class="block-md agri-color">
                                    <i class="fa fa-clock-o block-text"></i>
                                    <div class="block-text">{{ $t('menu.timezone') }}:</div>
                                    <div class="block-text">{{ proj.timezone }}</div>
                                </div>

                                <p v-if="proj.description" class="card-text">{{ proj.description }}</p>

                                <!-- Admin 備註 -->
                                <div v-if="user_admin" class="block-text">

                                    <b-alert v-if="proj.note" variant="secondary" show>
                                        <div class="block-text-sm"><i class="icon-menu"></i>{{ $t('menu.admin_note') }}：</div>
                                        <div v-html="proj.note" class="block-sm"></div>
                                    </b-alert>

                                </div>

                            </b-col>
                        </b-row>
                        
                        

                        <div>
                            <!-- 頁面按鈕 -->
                            <div class="card-subtitle mb-2">
                                
                                <b-button class="btn btn-cp" :to="{ name: 'Project History', params: { projectID: proj.id } }">
                                    <i class="fa fa-history"></i>{{ $t('menu.history') }}
                                </b-button>

                                <b-button class="btn btn-cp" :to="{ name: 'AgriDiary', params: { projectID: proj.id } }">
                                    <i class="fa fa-book"></i>{{ $t('menu.agridiary') }}
                                </b-button>
                                
                                <b-button class="btn btn-cp" :to="{ name: 'Custom Alert Rule Management', params: { projectID: proj.id } }">
                                    <i class="fa fa-gear"></i>{{ $t('menu.custom_alert_rule_management') }}
                                </b-button>

                                <LineNotifyButton :projectID="proj.id"
                                                :editable="true"
                                                :timezone="proj.timezone"
                                ></LineNotifyButton>
                                
                            </div>
                        </div>
                        <div v-if="user_admin">
                            <hr>
                            <h5 class="block-text">Admin {{ $t('menu.management') }}</h5>
                            <div class="block-text">
                                <b-button class="btn btn-outline-secondary block-text" :to="{ name: 'Project Management', params: { projectID: proj.id } }">
                                    <i class="fa fa-gear"></i>{{ $t('menu.project_management') }}
                                </b-button>
                                
                                <b-button class="btn btn-outline-secondary block-text" :to="{ name: 'Cropperiod Management', params: { projectID: proj.id } }">
                                    <i class="fa fa-gear"></i>{{ $t('menu.cropping_season_management') }}
                                </b-button>
                                
                                <b-button class="btn btn-outline-secondary block-text" :to="{ name: 'Device Management', params: { projectID: proj.id } }">
                                    <i class="fa fa-gear"></i>{{ $t('menu.device_management') }}
                                </b-button>
                                
                            </div>
                        </div>

                    </b-card>
                </b-collapse>

                <div>
                    
                    <div v-if="loading">
                        <AgriLoading :showCloud="true" :showAgriGift="true"></AgriLoading>
                    </div>

                    <!-- {{ proj }} -->
                    <div v-if="cropperiod_detail">
                        <div class="cropperiod-area">
                            <h3 class="area-title">{{ $t('menu.harvest_prediction') }} 工具 <i class="fa fa-mortar-board"></i></h3>
                            <b-card>
                                <HarvestPrediction  :timezone="proj.timezone"
                                                    :date_start="cropperiod_detail.start_date"
                                                    :crop_code="cropperiod_detail.cropinfo.full_code"
                                                    :device_id="get_PredictDevice"
                                ></HarvestPrediction>
                            </b-card>
                        </div>

                        <div class="cropperiod-area">
                            <h3 class="area-title">生長期資訊</h3>
                            <b-card>
                                <GrowthStageTasks :cropperiod="cropperiod_detail"></GrowthStageTasks>
                            </b-card>
                        </div>
                        

                        <div class="cropperiod-area">
                            <h3 class="area-title">即時氣象數值</h3>
                            <div v-for="device in device_list" :key="'device-data-block-' + device.hashid">
                                
                                <DevicePhoto v-if="device.type == 'camera'"
                                            :id="'device-chart-block-' + device.hashid"
                                            :device="device"
                                            :project_id="projID"
                                            :cropperiod_id="cropperiod_detail.id"
                                            :project_role="proj.role"
                                            :timezone="proj.timezone"
                                            :autoUpdate="true">
                                </DevicePhoto>
                                <DeviceChart v-else
                                            :id="'device-chart-block-' + device.hashid"
                                            :device="device"
                                            info_type="realtime"
                                            :showToolbox="true"
                                            :project_id="projID"
                                            :cropperiod_id="cropperiod_detail.id"
                                            :project_role="proj.role"
                                            :sensor_rules="{}"
                                            :timezone="proj.timezone">
                                ></DeviceChart>
                            </div>
                        </div>
                        
                    </div>

                </div>
            </div>
        </div>

     

    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import AgriLoading from '@/views/components/AgriLoading'
    import LineNotifyButton from '@/views/project/app/LineNotify_Button'
    import DeviceChart from '@/views/device/Chart_Device'
    import DevicePhoto from '@/views/device/Photo_Device'
    import GrowthStageTasks from '@/views/project/lite/GrowthStageTasks'
    import HarvestPrediction from '@/views/project/lite/HarvestPrediction'

    export default {
        props: {
        },
        components: {
            AgriLoading,
            LineNotifyButton,
            DeviceChart,
            DevicePhoto,
            GrowthStageTasks,
            HarvestPrediction,
        },
        data: function () {
            return {
                collapse_pi: true,
                loading: false,
            }
        },
        mounted ()
        {
            if (this.user_language) this.get_Cropperiod()
        },
        computed: {
            ...mapState({
                'user_admin': state => state.user.is_admin,
                'user_language': state => state.user.language,
                'project_detail': state => state.project.project_detail,
                'project_devices': state => state.project.project_devices,
                'cropperiod_detail': state => state.cropperiod.cropperiod,
            }),

            proj() {
                return this.project_detail
            },

            projID() {
                return this.$route.params.projectID;
            },

            device_list () {
                let _list = []
                if ( this.cropperiod_detail && this.cropperiod_detail.devices )
                {
                    this.cropperiod_detail.devices.forEach( _device => {
                    
                        _list.push( _device )
                    })
                }
                return _list
            },

            get_PredictDevice ()
            {
                if ( this.device_list.length > 0 ) return this.device_list[0].hashid
                
                return undefined
            },

        },
        watch: {


            user_language (val, oldVal)
            {
                if ( val )
                {
                    this.get_Cropperiod()
                }
            },
            projID (val, oldVal)
            {
                if ( val )
                {
                    this.get_Cropperiod()
                }
            },
        },
        methods: {

            style_Expiry (projInfo)
            {
                let _class = 'expiry-date'
                let _diff_days = this.$tools.date.countDays( projInfo.end_date, undefined, projInfo.timezone )
                if ( Math.abs( _diff_days ) <= 30 ) _class += '-due'
                return _class
            },

             get_Cropperiod ()
            {
                if ( this.project_detail && this.project_detail.cropperiods.length > 0 )
                {
                    let _first_cropperiod = this.project_detail.cropperiods[0]
                    this.$store.dispatch('cropperiod/getCropperiod', _first_cropperiod.id)
                        .then(res => {
                        })
                        .catch(err => {})
                }
            },

            getProjectDevices(_projectID) {
                this.$store.dispatch('project/getProjectDevices', _projectID)
                    .then(res => {})
                    .catch(err => {})
            },


        },
    }

</script>


<style lang="scss" scoped>

    .service-level {
        vertical-align: middle;
        margin-left: 10px;
        font-size: 1.2rem;
    }

    .block-service-level {
        display: inline-block;
        margin-left: 10px;
        margin-right: 10px;
    }

    .header-align-btn {
        font-size: 1.3rem;
    }

    .cropperiod-area
    {
        margin-left: 20px;
        margin-right: 30px;
        margin-bottom: 30px;

        .area-title
        {
            display: inline-block;
            padding: 5px 20px;
            margin: 10px 0px 0px 0px;
            background-color: #e4e4e4;
            border-radius: 3px;

            i {
                margin: 0px 0px 0px 8px;
                color: #9dac17;
            }
        }
    }

</style>
